import React, { createContext, useContext, useMemo, ReactNode } from 'react';
import { BrandConfig, getBrandFromHostname } from '../constants/brands';
import { getThemeForBrand } from '../constants/theme';

interface BrandContextType {
  brand: BrandConfig;
  theme: ReturnType<typeof getThemeForBrand>;
}

export const BrandContext = createContext<BrandContextType | undefined>(undefined);

export const BrandProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const brand = useMemo(() => {
    return getBrandFromHostname(window.location.hostname);
  }, []);

  const theme = useMemo(() => {
    return getThemeForBrand(brand);
  }, [brand]);

  return (
    <BrandContext.Provider value={{ brand, theme }}>
      {children}
    </BrandContext.Provider>
  );
};

export const useBrand = (): BrandContextType => {
  const context = useContext(BrandContext);
  if (!context) {
    throw new Error('useBrand must be used within a BrandProvider');
  }
  return context;
};
